import React, { useEffect, useState } from 'react'
import { constants } from '../../misc/constants';
import { generalAudioCaching, getGlobalTextSizeStyle, PageType, setFocus, TextHtmlTagType } from '../../misc/tools';
import { BaseConfig } from '../BaseConfig';
import Button2 from '../general/button2';
import PopUp2 from '../general/pop-up2';
import { UIProperties } from '../../cvp-webgames-core/Components/ui/UIProperties';
import "./question-type2-ui.css"
import ReplayContentUI from './replay-content-ui';
import Tools from '../../cvp-webgames-core/Misc/Tools';
import { coreGeneralQuestionUIBaseImplementation, GeneralQuestionUIConfig } from '../../cvp-webgames-core/Components/ui/react/core-general-question-ui';
import ReliabilityGaugeUI, { ReliabilityGaugeType } from './reliability-gauge-ui';
const QuestionType2UI = (props: UIProperties<QuestionType2UIConfig>) => {
	const generalProps: GeneralQuestionUIConfig = {
		onSubmitClicked: () => {
			const isCorrect = (selectedOptionIndex === 0 && props.parameters.isYesCorrect) || 
			(selectedOptionIndex === 1 && !props.parameters.isYesCorrect);
			const feedback = isCorrect ? props.parameters.correctFeedback : props.parameters.wrongFeedback;
			const selectedTitle = selectedOptionIndex === 0 ? 'Yes' : 'No'; 
			props.parameters.onSubmitClicked(isCorrect, feedback, selectedTitle, props.parameters);
		},
		audioUrl: props.parameters.audioUrl,
		options: [
			{
				description: 'Placeholder Text',
				feedbackHtml: '',
				isCorrect: props.parameters.isYesCorrect,
				score: 0,
				title: 'Yes',
				isSelected: false
			},
			{
				description: 'Placeholder Text',
				feedbackHtml: '',
				isCorrect: !props.parameters.isYesCorrect,
				score: 0,
				title: 'No',
				isSelected: false
			}
		],
		questionTitle: '',
		multipleChoice: false
	};
	const baseImplementation = coreGeneralQuestionUIBaseImplementation.getImplementation(generalProps);
    const selectedOptionIndex: number = baseImplementation.getSelectedOptions() as number;
    const [forcedUpdate, setForcedUpdate] = useState(0);
	useEffect(() => {
		if(forcedUpdate === 0) {
            const url = generalAudioCaching.getItemByKey(generalAudioCaching.audioKeys.music_marimba_chord_01).src;
			Tools.playOneShotSound(url);
            baseImplementation.init(() => {
                setForcedUpdate(forcedUpdate + 1);
            })
        }
	}, []);

	return (
		<div className="modal-disable-select question-type2-ui-container" style={{}}>
			<div className='gauges'>
                <div className='question-type2-ui-reliab-gauge'>
                    <ReliabilityGaugeUI percentage={props.parameters.percentage}
                                        type={ReliabilityGaugeType.Type1}></ReliabilityGaugeUI>
                </div>
            </div>
			<div aria-label='Question' className={`question-type2-ui-inner-container center-element ${constants.mainContent508Id}`}>
				<PopUp2
					titleLeft= {constants.projectTitle}
					titleRight= {props.parameters.title}
					subtitleRight= {props.parameters.subtitle}
					onRenderContent={() => {
						return (
							<div className='question-type2-ui-sub-container main-content-inner center-element-horizontal'>
								<div className='question-type2-ui-sub-container-inner'>
									<div className='center-element-horizontal question-type2-ui-sub-container-question-title'>
										<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}}className='center-element default-text'>{props.parameters.question}</p>
									</div>
									<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}}className='question-type2-ui-sub-container-option-below default-text'>Select an option below.</p>
									<div className='question-type2-ui-sub-container-question-yes'>
										<Button2 width= '100%'
											idFor508='question-type-2-content-top'
											height= '100%'
											onClick= {() => {baseImplementation.onOptionSelected(generalProps.options[0], 0, () => {
												setForcedUpdate(forcedUpdate + 1);
												setFocus('question-type-2-content-bottom');
											})}}
											onRenderContent= {() => {
												return (
													<div>
														<p className='small-text center-element' style={{position: 'absolute', ...getGlobalTextSizeStyle(TextHtmlTagType.p)}}>Yes</p>
														<div style={{
															position: 'absolute',
															width: '30px',
															height: '30px',
															top: '9px',
															left: '10px',
															backgroundColor: selectedOptionIndex !== 0 ? '#D3E1EA' : 'rgb(55, 70, 104)',
															borderRadius: '5px'
														}}></div>
														{selectedOptionIndex === 0 ? <div style={{
															position: 'absolute',
															left: '18px',
															top: '10px'
														}} className='question-type2-ui-arrow-container'>
															<i className='question-type2-ui-arrow'></i>
														</div> : null}
													</div>
												)
											}}
											backgroundColor='rgb(55, 70, 104)'
											hoverBgColor={constants.design.hoverColor1}
											isSelected= {selectedOptionIndex === 0}
											ariaLabel= {'Yes' + (selectedOptionIndex === 0 ? ' (selected)' : ' (unselected)')}></Button2>
									</div>
									<div className='question-type2-ui-sub-container-question-no'>
										<Button2 width= '100%'
											height= '100%'
											onClick= {() => {baseImplementation.onOptionSelected(generalProps.options[1], 1, () => {
												setForcedUpdate(forcedUpdate + 1);
												setFocus('question-type-2-content-bottom');
											})}}
											onRenderContent= {() => {
												return (
													<div>
														<p className='small-text center-element' style={{position: 'absolute', ...getGlobalTextSizeStyle(TextHtmlTagType.p)}}>No</p>
														<div style={{
															position: 'absolute',
															width: '30px',
															height: '30px',
															top: '9px',
															left: '10px',
															backgroundColor: selectedOptionIndex !== 1 ? '#D3E1EA' : 'rgb(55, 70, 104)',
															borderRadius: '5px'
														}}></div>
														{selectedOptionIndex === 1 ? <div style={{
															position: 'absolute',
															left: '18px',
															top: '10px'
														}} className='question-type2-ui-arrow-container'>
															<i className='question-type2-ui-arrow'></i>
														</div> : null}
													</div>
												)
											}}
											backgroundColor='rgb(55, 70, 104)'
											hoverBgColor={constants.design.hoverColor1}
											isSelected= {selectedOptionIndex === 1}
											ariaLabel= {'No' + (selectedOptionIndex === 1 ? ' (selected)' : ' (unselected)')}></Button2>
									</div>
								</div>
								<div className='center-element-horizontal question-type2-ui-sub-container-question-submit'>
									<Button2 width= '100%'
										idFor508='question-type-2-content-bottom'
										height= '100%'
										onClick= {() => {
											baseImplementation.onQuestionSubmitted();
											generalProps.onSubmitClicked(null, null, null)
										}}
										onRenderContent= {() => {
											return (
												<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}}className='small-text center-element'>Submit</p>
											)
										}}
										isSelected= {false}
										updateDisableOpacity={true}
										hoverBgColor={constants.design.hoverColor2}
										isDisabled={selectedOptionIndex===-1}
										ariaLabel= {'Submit'}></Button2>
								</div>
								
							</div>
							);
					}}></PopUp2>
			</div>
			<div className='question-type1-ui-replay-bttn'>
				<ReplayContentUI onReplayContentClicked={props.parameters.onReplayContentClicked}></ReplayContentUI>
			</div>
		</div>
	);

};

export interface QuestionType2UIConfig extends BaseConfig {
	title: PageType;
	subtitle: string;
	question: string;
	isYesCorrect: boolean;
    percentage?: number;
	onReplayContentClicked?: () => void;
	correctFeedback: string;
    audioUrl?: string;
	wrongFeedback: string;
	onSubmitClicked: (isCorrect: boolean, feedback: string, selectedTitle: string, parentQuestion: QuestionType2UIConfig) => void;
}

export default QuestionType2UI;